import {makeEpic, PAGE_SIZE, toBookmarksOrderBy} from '../common';

import {actions} from './slice';

const recoveryTokensEpicTypes = [
    actions.init.type,
    actions.setQueryFilter.type,
    actions.setTypeFilter.type,
    actions.loadNextPage.type,
    actions.changeOrder.type,
];

export const recoveryTokensEpic = makeEpic(
    (state) => state.recoveryTokens,
    (state, {sdk}) =>
        sdk.wiki.recoveryTokens({
            cursor: state.nextCursor ? state.nextCursor : undefined,
            pageSize: PAGE_SIZE,
            query: state.filters.query,
            orderBy: toBookmarksOrderBy(state.orderBy),
            orderDirection: state.orderDirection,
            tokenType: state.filters.type,
        }),
    actions,
    recoveryTokensEpicTypes,
    'recoveryTokensError',
);
